import { render, staticRenderFns } from "./CreateForwarderModal.vue?vue&type=template&id=5b8654cc&"
import script from "./CreateForwarderModal.vue?vue&type=script&lang=js&"
export * from "./CreateForwarderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b8654cc')) {
      api.createRecord('5b8654cc', component.options)
    } else {
      api.reload('5b8654cc', component.options)
    }
    module.hot.accept("./CreateForwarderModal.vue?vue&type=template&id=5b8654cc&", function () {
      api.rerender('5b8654cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Email/CreateForwarderModal.vue"
export default component.exports